import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { GraduationCap, BedDouble, Activity, Building, UserX, BarChart3 } from 'lucide-react';

interface Props {
  overdueCount: number;
  unbeddedCount: number;
  totalServices: number;
  facilityAlertCount: number;
  clientAlertCount: number;
  totalActions: number;
}

export const ActivitySummaryCards = ({
  overdueCount,
  unbeddedCount,
  totalServices,
  facilityAlertCount,
  clientAlertCount,
  totalActions,
}: Props) => {
  const cards = [
    {
      label: 'Overdue Trainings',
      value: overdueCount,
      icon: GraduationCap,
      color: 'text-red-600',
      bg: 'bg-red-50',
    },
    {
      label: 'Unbedded Clients',
      value: unbeddedCount,
      icon: BedDouble,
      color: 'text-orange-600',
      bg: 'bg-orange-50',
    },
    {
      label: 'Total Services',
      value: totalServices,
      icon: Activity,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
    },
    {
      label: 'Facility Alerts',
      value: facilityAlertCount,
      icon: Building,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
    },
    {
      label: 'Client Alerts',
      value: clientAlertCount,
      icon: UserX,
      color: 'text-purple-600',
      bg: 'bg-purple-50',
    },
    {
      label: 'Total Activity',
      value: totalActions,
      icon: BarChart3,
      color: 'text-gray-600',
      bg: 'bg-gray-50',
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
      {cards.map(c => (
        <Card key={c.label}>
          <CardContent className="p-4 flex items-center gap-3">
            <div className={`p-2 rounded-lg ${c.bg}`}>
              <c.icon className={`h-5 w-5 ${c.color}`} />
            </div>
            <div className="min-w-0">
              <p className="text-xs text-muted-foreground">{c.label}</p>
              <p className="text-lg font-semibold">{c.value}</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
